import { Injectable } from '@angular/core';
import { UtilService } from '../util/util.service';
import { LogService } from '../log/log.service';
import { LocalStorageService } from '../storage/local-storage.service';
import { AuthUserInfo } from '../auth/auth-user-info.model';
import { AuthService } from '../auth/auth.service';
import { EnvironmentService } from '../environment/environment.service';
import { HttpRequestService } from '../http/http-request.service';
import { HttpRequestOptions } from '../http/http-request-options.model';
import { NameValue } from '../model/name-value.model';
import { TokenService } from '../auth/token.service';
import { NotificationService } from '../notification';
import { TenantAuthorityEnum } from '../auth/enum/tenant-authority.enum';
//import { Http, Headers, Response, RequestOptions } from '@angular/http';
//import 'rxjs/add/operator/toPromise';

@Injectable()
export class AppLoadService {
  //private _httpClient: Http;
  private _httpRequestService: HttpRequestService;
  private _utilService: UtilService;
  private _logService: LogService;
  private _authService: AuthService;
  private _identityServerRoot: string;
  private _environmentService: EnvironmentService;

  constructor(
    httpRequestService: HttpRequestService,
    utilService: UtilService,
    logService: LogService,
    environmentService: EnvironmentService,
    authService: AuthService,
    private _tokenService: TokenService,
    private _notificationService: NotificationService
  ) {
    this._httpRequestService = httpRequestService;
    this._utilService = utilService;
    this._logService = logService;
    this._environmentService = environmentService;
    this._authService = authService;

    this._identityServerRoot = this._environmentService.getEnvironmentConfig().WeblinkAuthUrl;
  }

  initializeApp(): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      try {
        this._logService.log('App intialization', 'App intializing');

        //look for auth tokens in url and grab them and authenticate the user
        if (this._authService.hasAuthenticationTokensInUrl() == true) {
          //get userinfo from identity server
          this._logService.log('App intialization', 'Auth tokens found');
          return this.extractAuthenticationTokensFromUrl().then((data: boolean) => {
            if (data == true) {
              this._logService.log('App intialization', 'Auth tokens extracted');
              resolve();
            } else {
              this._logService.log('App intialization', 'Auth tokens failed to be extracted');
              resolve();
            }
          });
        } else if (this._authService.hasPkceCodeInUrl()) {
          return this._authService.exchangePkceCodeForTokens().then((data: boolean) => {
            resolve();
          });
        } else {
          this._logService.log('App intialization', 'No Auth tokens found');
          resolve();
        }
      } catch (error) {
        this._logService.error('App intialization Error.  ' + error.toString());
        reject(error);
      }
    });
  }

  private extractAuthenticationTokensFromUrl = (): Promise<boolean> => {
    if (this._authService.hasAuthenticationTokensInUrl()) {
      //clear out all stored user data and get new user data
      this._authService.clearTokensAndUserInfo();
    }
    if (window.location.hash) {
      var hash = window.location.hash.substr(1);
      if (this._utilService.startswith(hash.toLowerCase(), 'code=')) {
        var result = hash.split('&').reduce(function (resultInner: any, item: any) {
          var parts = item.split('=');
          resultInner[parts[0]] = parts[1];
          return resultInner;
        }, {});

        if (result.access_token) {
          if (!this._tokenService.isBackOfficeToken(result.access_token)) {
            return Promise.resolve(false);
          }
          this._authService.setAccessToken(result.access_token);
          if (result.expires_in) {
            //get access token expires in
            var expiresInSecs = parseInt(result.expires_in) - 100;
            var expiresInMilliSecs = 1000 * expiresInSecs;
            var expireDate = new Date();
            expireDate.setTime(expireDate.getTime() + expiresInMilliSecs);
            this._authService.setAccessTokenExpires(expireDate);
          }

          if (result.id_token) {
            this._authService.setIdToken(result.id_token);
            var idExpireDate = new Date();
            //expire in 12 hours
            idExpireDate.setHours(idExpireDate.getHours() + 12);
            this._authService.setIdTokenExpires(idExpireDate);
          }

          //get user info details
          let url: string = this._identityServerRoot + '/connect/userinfo';

          let currentAccessToken: string = result.access_token;

          let options = new HttpRequestOptions();
          options.Headers.push(new NameValue('Content-Type', 'application/x-www-form-urlencoded'));
          options.Headers.push(new NameValue('Authorization', 'Bearer ' + currentAccessToken));
          options.Headers.push(new NameValue('Cache-Control', 'no-cache'));
          options.Headers.push(new NameValue('Pragma', 'no-cache'));

          return new Promise((resolve, reject) => {
            try {
              this._httpRequestService.get(url, options).then(
                (data: AuthUserInfo) => {
                  this._authService.setUserInfo(data, TenantAuthorityEnum.Establish);
                  resolve(true);
                },
                (error: any) => {
                  this._logService.error('Error getting userinfo ' + error.toString());
                  reject(error);
                }
              );
            } catch (error) {
              this._logService.error('App intialization Error.  Error calling ' + url + '.   ' + error.toString());
              reject(error);
            }

            //let requestOptions: RequestOptions = new RequestOptions({
            //  body: '', //if this isn't set in rc5 it will break
            //  headers: authHeaders
            //});

            //return new Promise((resolve, reject) => {
            //  try {

            //    this._httpClient.get(url, requestOptions)
            //      .toPromise().then((response: Response) => {

            //        let responseData = this.extractData(response);
            //        this._authService.setUserInfo(responseData);
            //        resolve(true);

            //      }, ((error: any) => {
            //        this._logService.error("Error getting userinfo " + error.toString());
            //        reject(error);
            //      })
            //      );

            //  }

            //  catch (error) {
            //    this._logService.error("App intialization Error.  Error calling " + url + ".   " + error.toString());
            //    reject(error);
            //  }
          });
        } else {
          return Promise.resolve(false);
        }
      } else {
        return Promise.resolve(false);
      }
    } else {
      return Promise.resolve(false);
    }
  };

  //private extractData = (res: Response): any => {

  //  let data: any = null;
  //  if (res.status == 204) {
  //    //this is a no content response A VOID

  //  } else {
  //    data = res.json();
  //    this._utilService.convertJsonUtcServerDateStringsToDates(data);

  //  }

  //  return data; //body.data || {};
  //}
}
